import R from 'ramda'

const HASHTAG_TRIGGER_TYPE = 'HASHTAG'
const HASHTAG_DISPLAY_TYPE = 'Match hashtag'

const isHashtagFormTrigger = R.propEq('type', HASHTAG_DISPLAY_TYPE)

const convertHashtagFormTriggerToWidgetTrigger = R.applySpec({
  type: R.always(HASHTAG_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T,
  excludeRetweet: R.always(true)
})

export { isHashtagFormTrigger, convertHashtagFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/hashtag.js